import type {
  GetGroupVehicleRequest,
  GetGroupsRequest,
  Group,
  GroupRequest,
  GroupVehicleResponse,
  GroupsResponse,
  VehiclesInGroup,
} from '../types/Group';
import { api } from './api';

export const groupApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllGroups: builder.query<Group[], void>({
      query: () => {
        return `groups/?no_pagination=true`;
      },
      providesTags: ['AllGroups'],
    }),
    getGroups: builder.query<GroupsResponse, GetGroupsRequest>({
      query: ({ page, pageSize, group_name, group_id, ordering }) => {
        const params = new URLSearchParams();

        if (page) params.set('page', String(page));
        if (pageSize) params.set('page_size', String(pageSize));
        if (group_name) params.set('group_name', group_name);
        if (group_id) params.set('group_id', group_id);
        if (ordering) params.set('ordering', ordering);

        return `groups/?${params.toString()}`;
      },
      providesTags: ['AllGroups'],
    }),
    getGroup: builder.query<Group, string>({
      query: id => ({
        url: `group/${id}/`,
        method: 'GET',
      }),
      providesTags: ['Group'],
    }),
    getVehiclesInGroup: builder.query<GroupVehicleResponse, GetGroupVehicleRequest>({
      query: ({ page, pageSize, group_id }) => {
        const params = new URLSearchParams();
        if (page) params.set('page', String(page));
        if (pageSize) params.set('page_size', String(pageSize));
        return `group/vehicles/${group_id}/?${params.toString()}`;
      },
      providesTags: ['Group'],
    }),
    getAllVehiclesInGroup: builder.query<VehiclesInGroup[], string>({
      query: id => {
        return `group/vehicles/${id}/?no_pagination=true`;
      },
      providesTags: ['Group'],
    }),
    deleteVehicleGroup: builder.mutation<void, { grpId: string; vehicleId: string }>({
      query: ({ grpId, vehicleId }) => ({
        url: `group/vehicle/${grpId}/${vehicleId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Group'],
    }),
    createGroup: builder.mutation<Group, GroupRequest>({
      query: group => ({
        url: 'create-group/',
        method: 'POST',
        body: group,
      }),
      invalidatesTags: ['AllGroups'],
    }),
    editGroup: builder.mutation<Group, Partial<Group>>({
      query: group => ({
        url: `group/${group.id}/`,
        method: 'PATCH',
        body: group,
      }),
      invalidatesTags: ['AllGroups', 'Group'],
    }),
    deleteGroup: builder.mutation<void, string>({
      query: id => ({
        url: `group/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllGroups'],
    }),
  }),
});

export const {
  useGetAllGroupsQuery,
  useLazyGetGroupsQuery,
  useLazyGetGroupQuery,
  useLazyGetVehiclesInGroupQuery,
  useLazyGetAllVehiclesInGroupQuery,
  useDeleteVehicleGroupMutation,
  useCreateGroupMutation,
  useEditGroupMutation,
  useDeleteGroupMutation,
} = groupApi;
